import axios from 'axios';
import config from '../config/index';
// import store from '../store/index'
import { Message } from 'element-ui';
import router from '../router/index';

// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = `${config.SYSTEM_URL}`;
} else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = `${config.SYSTEM_URL}`;
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = `${config.SYSTEM_URL}`;
}

// 请求超时时间
axios.defaults.timeout = 30000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.withCredentials = true;
// 请求拦截器
axios.interceptors.request.use(config => {
    if (sessionStorage.getItem('token')) {
        //  存在将token写入 request header
        config.headers.token = `${sessionStorage.getItem('token')}`;
    }
    return config;
}, err => {
    // return Promise.error(error);
    // Message.error({
    //     message: '退出登陆',
    //     onClose: function () {
    //     router.push({name: 'login'});
    //     }
    // })
    return Promise.reject(err);
})

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code === 200) {
            return Promise.resolve(response);
        } else {
            Message.error(response.data.message);
            switch (response.data.code){
                case 401:
                    setTimeout(() => {
                        sessionStorage.removeItem('token');
                        router.replace({
                            path: '/login',
                            query: { redirect: router.currentRoute.fullPath }
                        });
                    }, 1000);
                break;
                // 账号已在其它地方登录
                case 5107:
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                break;
                case 5110:
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                    break;
                // case 5000:
                //     setTimeout(() => {
                //         router.replace({
                //             path: '/login',
                //             query: {
                //                 redirect: router.currentRoute.fullPath
                //             }
                //         });
                //     }, 1000);
                // break;
            }
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        if (error.response.code) {
            switch (error.response.code) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 403:
                    router.replace({
                        path: '/login',
                        query: { redirect: router.currentRoute.fullPath }
                    });
                    break;
                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 401:
                    Message.error('登录过期，请重新登录!');
                    // 清除token
                    sessionStorage.removeItem('token');
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                    break;
                // 404请求不存在
                case 404:
                    Message.error('网络请求不存在!');
                    router.replace('/404')
                break;
                // 账号已在其它地方登录
                case 5110:
                    Message.error('账号在其他地方登录!');
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                break;
                //登录已过期
                case 5107:
                    Message.error('登录已过期!');
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                break;
                case 500:
                    Message.error('网络请求出错!');
                break;
                // 其他错误，直接抛出错误提示
                default:
                    Message.error(error.response.message);
            }
            return Promise.reject(error.response);
        }
    }
);

/** get方法，对应get请求 **/
export function get(url, params){
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            params: params
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}
/** post方法，对应post请求 **/
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url,params)
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}

/** delete方法，对应delete请求 **/
 export function del(url, params){
    return new Promise((resolve, reject) =>{
        axios.delete(url, {
            data: params
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}

/** put修改 **/
export function put(url, params){
    return new Promise((resolve, reject) =>{
        axios.put(url, params)
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}
